import $ from 'jquery';
import { TweenMax, TimelineLite, Power1 } from 'gsap';


const socialContainer = $('.addthis_toolbox');

if (socialContainer.length) {

  setTimeout(() => {
    const socialButtons = $('.addthis_link');

    const socialTimeline = new TimelineLite();
    socialTimeline.staggerFrom(socialButtons, 0.15, { ease: Power1.easeOut, autoAlpha: 0, y:-5 }, 0.05);
    socialTimeline.pause();

    socialContainer.hover(function(){
      socialTimeline.play();
    },
    function(){
      socialTimeline.reverse();
    });

  }, 1000);

}
